// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".croppa-container[data-v-7efdbdc1]{background-color:#ecf2f9;border:2px solid #afcbf2;border-radius:0;max-height:300px;max-width:300px}.croppa-container[data-v-7efdbdc1]:hover{opacity:1;background-color:#e0eeff}", ""]);
// Exports
module.exports = exports;
